<template>
  <div class="ticket-info-form-part">
    <form class="form-horizontal">
      <div class="form-group">
        <label for="inputEmail3" class="col-sm-2 control-label">取衣方式</label>
        <div class="col-sm-10">
          <select class="form-control" v-model.number="ticket.takeOffClotheWay">
            <option value="0">自己</option>
            <option value="1">免费收送</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">收衣方式</label>
        <div class="col-sm-10">
          <select class="form-control" v-model.number="ticket.getClotheWay">
            <option :value="0">自己</option>
            <option :value="1">免费收送</option>
          </select>
        </div>
      </div>
      <alert type="info"><b>点击右边图标，选择取衣日期</b></alert>
      <div class="form-group">
        <label class="col-sm-2 control-label">取衣日期</label>
        <dropdown class="col-sm-10">
          <div class="input-group">
            <input class="form-control" type="text" v-model="ticket.planTakeAwayAt">
            <div class="input-group-btn">
              <button class="btn btn-default dropdown-toggle" type="button"><i class="glyphicon glyphicon-calendar"></i></button>
            </div>
          </div>
          <template slot="dropdown">
            <li>
              <date-picker v-model="ticket.planTakeAwayAt"></date-picker>
            </li>
          </template>
        </dropdown>
      </div>
       <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label">备注</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" id="inputEmail3" placeholder="备注">
              </div>
            </div>
    </form>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    ticket: {
      type: Object,
      default: function() {
        return {
          getClotheWay: 0,
          takeOffClotheWay: 0,
          planTakeAwayAt: moment().add(7, 'days')
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/forms/TicketInfo.vue